import React from "react";
import useLayout from "~/hooks/useLayout";
import useMount from "~/hooks/useMount";

import headerImage from "~/images/header_image.png";
import abordableIconWhite from "~/images/abordable_icon_white.svg";
import hearthIconWhite from "~/images/heart_icon_white.svg";
import accessibleIconWhite from "~/images/accessible_icon_white.svg";
import Slider from "./components/slider/Slider";
import { Link } from "react-router-dom";

export default function AboutPage() {
  const { setLayout } = useLayout();

  useMount(() => {
    setLayout({
      title: "Comment ça marche",
      activeMenuKeys: ["about"],
    });
  });

  return (
    <>
      <div className="h-[88vh] flex flex-col justify-center ">
        <div className="flex lg:justify-around md:justify-center items-center px-4 w-full">
          <div className="h-full lg:w-[45%] md:w-[60%] flex flex-col justify-center lg:px-20 gap-y-10">
            <h1 className="font-bold text-4xl">
              Entreprises, influenceurs, <br />
              <span className="text-primary">rencontrez-vous !</span>
            </h1>
            <h2 className="text-2xl">
              Découvrez Influx, la nouvelle application mobile basée sur la
              micro-influence.
            </h2>
            <div className="bg-primary py-2 px-4 rounded-2xl rounded-tl-none w-fit text-white text-xl shadow-xl shadow-primary/30">
              Bonjour, disponible pour échanger ?
            </div>
            <div className="bg-tertiary py-2 px-4 rounded-2xl rounded-tr-none w-fit text-white text-xl self-end shadow-xl shadow-tertiary/30">
              Bonjour, oui avec plaisir !
            </div>
          </div>
          <div className="w-[40%] h-fit lg:flex hidden items-center justify-center">
            <img src={headerImage} alt="" className="max-w-[95%]" />
          </div>
        </div>
      </div>

      <Slider />

      <section className="bg-gray-100 flex flex-col md:flex-row justify-around py-10 mt-16 mb-10">
        <div className="gap-y-4 flex flex-col justify-center items-center h-56 px-4 md:px-8">
          <div className="flex items-center justify-center rounded-full border border-primary">
            <div className="h-20 w-20 rounded-full bg-primary p-2 border">
              <img
                src={abordableIconWhite}
                alt="icon"
                className="w-full text-white"
              />
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl text-primary">Aucune commission</div>
            <div className="text-lg">
              Aucune commission sur vos partenariats et placements de produit.
            </div>
          </div>
        </div>
        <div className="gap-y-4 flex flex-col justify-center items-center h-56 px-4 md:px-8">
          <div className="flex items-center justify-center rounded-full border border-primary">
            <div className="h-20 w-20 rounded-full bg-primary p-2 border">
              <img
                src={hearthIconWhite}
                alt="icon"
                className="w-full text-white"
              />
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl text-primary">Simple et intuitif</div>
            <div className="text-lg">
              Une application pensée pour tous, prise en main rapide garantie.
            </div>
          </div>
        </div>
        <div className="gap-y-4 flex flex-col justify-center items-center h-56 px-4 md:px-8">
          <div className="flex items-center justify-center rounded-full border border-primary">
            <div className="h-20 w-20 rounded-full bg-primary p-2 border">
              <img
                src={accessibleIconWhite}
                alt="icon"
                className="w-full text-white"
              />
            </div>
          </div>
          <div className="text-center">
            <div className="text-2xl text-primary">Accessible à tous</div>
            <div className="text-lg">
              Peu importe la taille de votre communauté ou de votre entreprise.
            </div>
          </div>
        </div>
      </section>
      <section className="flex flex-col py-14">
        <p className="text-gray-700 md:text-2xl text-lg text-center mb-6 px-4">
          Influx offre un espace personnalisé aux besoins de chacun.
        </p>
        <div className="flex justify-center space-x-10">
          <div className="flex justify-center items-center">
            <div className="py-4 flex border:primary flex-col space-y-2 justify-center items-center uppercase text-primary">
              <Link
                to={`/influencers`}
                className="text-white bg-primary md:text-xl text-bases py-2 px-4 rounded-lg shadow-md shadow-primary/30 cursor-pointer border border-primary hover:bg-white hover:text-primary transition duration-200"
              >
                Influenceurs
              </Link>
            </div>
          </div>
          <div className="flex justify-around items-center">
            <div className="py-4 flex flex-col space-y-2 justify-center items-center uppercase text-white">
              <Link
                to={`/companies`}
                className="text-primary border border-primary md:text-xl text-base py-2 px-4 rounded-lg shadow-md shadow-white/30 cursor-pointer hover:bg-primary hover:border-transparent hover:text-white transition duration-200"
              >
                Entreprises
              </Link>
            </div>
          </div>
        </div>
      </section>
    </>
  );
}
